module.exports = _.isNil;